module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-3500-Classes-Inactive-4aa88ade8e205a94d8e3288f87b128f8.png";